import about1 from '../assets/about02.png';
import about2 from '../assets/about04.png';
import about3 from '../assets/about03.png';
import about4 from '../assets/about01.png';

export const WorkData= [
    {
        image: about1,
        category: 'Web App',
        title: 'Gym Project',
        about : 'A Gym website build in React',
        github: 'https://github.com/cobrianz/fitness-club',
        deploy: 'https://strogym.pages.dev/',
      },{
        image: about2,
        category: 'Web App',
        title: 'E-commerce Webite',
        about: 'Ecommerce webite build in PHP, and Javascript',
        github: 'https://github.com/cobrianz/eduka-ecommerce',
        deploy: 'https://cobrianz.github.io/eduka-ecommerce/',
      },
      {
        image: about3,
        category: 'Web App',
        title: 'Advanced Dashboard',
        about : 'Advanced dashboard build in Javascript and SCSS',
        github : 'https://github.com/cobrianz/Admin-panel',
        deploy : 'https://cobrianz.github.io/Admin-panel/',
      },
      {
        image: about4,
        category: 'Web App',
        title: 'E-Portifolio',
        about : 'E-portifolio built with HTML, JS and CSS3', 
        github: 'http://github.com/cobrianz/brianportfolio',
        deploy: 'https://cobrianz.github.io/brianportfolio/#',
      }

]